import React from 'react';
import { useGetTheatreByCodeQuery } from '../../services/moviesData';
import '../../stylesheet/movieTiming.css';
import Button from 'react-bootstrap/Button';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useNavigate } from 'react-router-dom';

export default function MovieTimingCard({ theaterId }) {
  const { data, isLoading, error } = useGetTheatreByCodeQuery(theaterId);
  const navigate = useNavigate();

  const goToBooking = (theatre, timing) => {
    navigate(`/endpage/${theatre}/${timing}`);
  };

  const digitList = [2, 3, 4];

  function RandomNumber(digitList) {
    const randomIndex = Math.floor(Math.random() * digitList.length);
    const randomDigit = digitList[randomIndex];
    return randomDigit;
  }

  const theaters = Object.values(data || {});

  return (
    <div className='container'>
      {isLoading && <p>Loading data...</p>}
      {error && <p>Error: {error.message}</p>}
      {theaters.length > 0 &&
        theaters.map((item, index) => (
          <div className='content' key={index}>
            <div className='title'>{item.theaterName}</div>
            <div className='info'>Info</div>
            <div className='showtimes'>
              {['10:00 AM', '02:00 PM', '06:00 PM', '09:00 PM']
                .splice(0, RandomNumber(digitList))
                .map((placement, placementIndex) => (
                  <OverlayTrigger
                    key={placementIndex}
                    placement='top'
                    overlay={
                      <Tooltip id={`tooltip-top`}>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <p style={{ marginRight: '10px' }}>
                            {' '}
                            150RS <br /> FirstClass <br /> available{' '}
                          </p>
                          <p style={{ marginRight: '10px' }}>
                            {' '}
                            150RS <br /> FirstClass <br /> available{' '}
                          </p>
                          <p>
                            {' '}
                            150RS <br /> FirstClass <br /> available{' '}
                          </p>
                        </div>
                      </Tooltip>
                    }
                  >
                    <Button
                      variant='secondary'
                      className='showtime-button'
                      onClick={() => goToBooking(item.theaterName, placement)}
                    >
                      {placement}
                    </Button>
                  </OverlayTrigger>
                ))}
            </div>
          </div>
        ))}
    </div>
  );
}
